import ProductListing from "./Index";
export default function AmazonProducts() {
  return <ProductListing source="amazon" />;
}
